/* =========================================================
   MIRAVA CART DRAWER V2 — Shopify AJAX integration
   Real cart data via /cart.js, /cart/add.js, /cart/change.js
   ========================================================= */
/* =========================================================
   AUDIT FIXES (this pass) — see chat for full write-up
   1. FREE GIFT badge was queried but never toggled — wired up.
   2. A single global "addInFlight" flag blocked adding a 2nd
      upsell product while a 1st add was still in flight — removed;
      per-product locking (pendingAddIds) already covers double-clicks.
   3. Empty-cart milestone message used curCart.items.length===0
      instead of the optimistic isEmpty check used everywhere else —
      fixed so it matches renderItems()'s empty logic.
   4. Items merged in via the upsell "Add" button never got a
      lineOrder entry, so they could jump position on the next
      re-render before the next full /cart.js refresh — fixed.
   5. Out-of-order network responses (e.g. two quantity changes on
      two different lines resolving out of order) could let a
      stale response silently overwrite a newer cart state —
      added a monotonic "latest applied" guard shared by every
      code path that can push cart data into the UI.
   6. The header cart bubble was force-reset to 0 the instant the
      script loaded, before the first real /cart.js response came
      back — caused a visible flash on pages where the bubble was
      already server-rendered with the correct count. Removed the
      premature call; the first refreshCart() sets it once, correctly.
   7. The just-reached milestone animation class could get wiped by
      a re-render (any cart action) before its 0.72s animation
      finished, causing a visual jump-cut — now preserved.
   8. Upsell "Add to cart" failures always showed the generic error
      message even when Shopify returned a specific reason (e.g.
      sold out) — now surfaces that reason, matching the quantity
      +/- error handling.
   9. Cart line thumbnails appended "&width=120" to item.image
      assuming a "?" was already present in the URL — hardened.
   ========================================================= */
(function () {
  var CFG = window.MIRAVA_CART_CONFIG || {};
  var FREE_SHIP = CFG.freeShip || 699, FREE_GIFT = CFG.freeGift || 999;
  var drawer = document.getElementById('miravaCartDrawer');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-items]');
  var countEl = drawer.querySelector('[data-cart-count]');
  var totalEl = drawer.querySelector('[data-cart-total]');
  var totalMrpEl = drawer.querySelector('[data-cart-total-mrp]');
  var savingEl = drawer.querySelector('[data-savings]');
  var fillEl = drawer.querySelector('[data-milestone-fill]');
  var msgEl = drawer.querySelector('[data-milestone-msg]');
  var giftBadge = drawer.querySelector('[data-gift-badge]');
  var stepsEl = drawer.querySelector('[data-milestone-steps]');
  var upsellEl = drawer.querySelector('[data-upsell-items]');
  var errorEl = drawer.querySelector('[data-cart-error]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var checkoutEl = drawer.querySelector('a.checkout');
  var discSection = drawer.querySelector('[data-discount]');
  var upsellSection = drawer.querySelector('[data-upsell-section]');
  var discToggle = drawer.querySelector('[data-discount-toggle]');
  var discPanel = drawer.querySelector('[data-discount-panel]');
  var discInput = drawer.querySelector('[data-discount-input]');
  var discApply = drawer.querySelector('[data-discount-apply]');
  var discMsg = drawer.querySelector('[data-discount-msg]');
  var discountInFlight = false;
  var coupsEl = drawer.querySelector('[data-coupons]');
  var coupsViewEl = drawer.querySelector('[data-coupons-view]');
  var coupsDrawerEl = drawer.querySelector('[data-coupons-drawer]');
  var coupsDrawerListEl = drawer.querySelector('[data-coupons-list]');
  var totalDetailsEl = drawer.querySelector('[data-total-details]');
  var totalToggleEl = drawer.querySelector('[data-total-toggle]');
  var giftBannerEl = drawer.querySelector('[data-gift-banner]');
  var giftPopupEl = drawer.querySelector('[data-gift-popup]');
  var giftItemEl = drawer.querySelector('[data-gift-item]');
  var giftDismissed = false;
  var giftPopupShown = false;
  var giftClaiming = false;
  var milestoneState = [false, false, false];
  var milestoneReady = false;
  var curCart = { items: [], total_price: 0, item_count: 0 };
  var UPSELL = (window.MIRAVA_UPSELL || []);

  /* Reliability state: cartSeq is a monotonic id handed out to every
     network operation that can push authoritative cart data into the UI
     (a /cart.js refresh, a /cart/change.js quantity update, or a
     /cart/add.js merge). lastAppliedSeq is the id of whichever one most
     recently actually rendered. Any response that resolves with a seq
     lower than lastAppliedSeq is out of order (arrived late) and is
     dropped instead of silently overwriting newer state. */
  var cartSeq = 0;
  var lastAppliedSeq = 0;

  function nextMutationSeq() {
    return ++cartSeq;
  }

  /* Applies `cart` (a full /cart.js-shaped object) unless a newer
     mutation has already been applied. Returns true if it rendered. */
  function tryApplyCart(seq, cart) {
    if (seq < lastAppliedSeq) return false;
    lastAppliedSeq = seq;
    applyCart(cart);
    return true;
  }

  /* For mutations (like a merged add.js response) that update curCart
     directly instead of going through applyCart — still claims the seq
     so an older, later-resolving refresh can't stomp on it. */
  function markSeqApplied(seq) {
    if (seq > lastAppliedSeq) lastAppliedSeq = seq;
  }

  /* Deterministic per-line quantity queue.
     desiredQty[key]  — the latest user-requested ABSOLUTE quantity, updated on
                        every +/- click (clicks are never dropped).
     inFlightQty[key] — the quantity currently being written to Shopify.
     One /cart/change.js per line at a time; after each response the newest
     desired quantity is sent again if it differs, until Shopify converges.
     Keys are the stable Shopify line key, so removals can't corrupt targets. */
  /* Quantity state uses stable logical identities. Cart mutations are globally serialized because change.js returns a full cart snapshot. */
  var desiredQty = {};
  var inFlightMutation = false;
  var refreshQueued = false;
  var pendingAddIds = {};
  var lastServerCart = null;
  var DEFAULT_CART_ERROR = 'Couldn\u2019t update your cart. Please try again.';

  /* Row order survives Shopify line-key changes and temporary removal/re-add. */
  var lineOrder = {};
  var lineOrderSeq = 0;
  var lineSnapshots = {};
  var pendingOrderByVariant = {};
  var mergedBumpIdentities = {};

  var otherTotal = 0;
  var otherDiscount = 0;
  var errorTimer = null;

  function money(cents) {
    var n = Math.round(cents / 100);
    return '\u20B9' + n.toLocaleString('en-IN');
  }

  function fmtINR(n) {
    n = Math.round(n);
    return '\u20B9' + n.toLocaleString('en-IN');
  }

  /* Safely append a query param to a Shopify CDN image URL regardless of
     whether it already carries one (e.g. "...?v=169..."). */
  function withParam(url, param) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + param;
  }

  /* Opening must not duplicate network work: if an authoritative refresh is
     already in flight, join it; if the cart was just fetched (mutation or a
     MiravaCartRefresh() call), render it immediately. Only a genuinely stale
     open triggers a /cart.js request. */
  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* Always refresh on open so a just-completed Add to Cart can never be hidden by a stale in-flight /cart.js read. */
    refreshCart(true).catch(function () {
      showCartError();
    });

    return Promise.resolve();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.MiravaOpenCart = open;
  window.MiravaCloseCart = close;

  function inCart(key) {
    return curCart.items.some(function (it) {
      return String(it.variant_id) === String(key);
    });
  }

  /* ---------- Effective (optimistic) cart state ----------
     curCart/lastServerCart always stay authoritative. Optimistic quantity
     changes live in desiredQty (queued) / inFlightQty (being written) and
     every render reads through these helpers, so the drawer shows the clicked
     value instantly and snaps to Shopify's response when it arrives. */
  function findItem(key) {
    for (var i = 0; i < curCart.items.length; i++) {
      if (curCart.items[i].key === key) return curCart.items[i];
    }
    return null;
  }

  function normalizeProperties(props) {
    var out = {};
    if (!props || typeof props !== 'object') return out;
    Object.keys(props).sort().forEach(function (k) {
      var v = props[k];
      if (v === null || typeof v === 'undefined' || v === '') return;
      out[k] = String(v);
    });
    return out;
  }

  function lineIdentity(it) {
    var spa = it && it.selling_plan_allocation;
    var planId = spa && spa.selling_plan ? spa.selling_plan.id : '';
    return String(it && it.variant_id || '') + '::' + String(planId || '') + '::' + JSON.stringify(normalizeProperties(it && it.properties));
  }

  function findItemByIdentity(identity) {
    for (var i = 0; i < curCart.items.length; i++) {
      if (lineIdentity(curCart.items[i]) === identity) return curCart.items[i];
    }
    return null;
  }

  function ensureLineOrder(identity, variantId) {
    if (lineOrder[identity] !== undefined) return lineOrder[identity];
    var pending = variantId ? pendingOrderByVariant[String(variantId)] : undefined;
    if (pending !== undefined) {
      lineOrder[identity] = pending;
      delete pendingOrderByVariant[String(variantId)];
      return pending;
    }
    lineOrder[identity] = lineOrderSeq++;
    return lineOrder[identity];
  }

  function findUpsell(id) {
    for (var i = 0; i < UPSELL.length; i++) {
      if (UPSELL[i].id == id) return UPSELL[i];
    }
    return null;
  }

  /* ---------- Variant-level MRP resolution ----------
     Cart lines carry variant_id + handle but compare_at_price is unreliable
     (null on live lines even when a compare-at exists). Authoritative source:
     ${Shopify.routes.root}products/{handle}.js -> variants[] -> the EXACT
     variant's compare_at_price (already in paise/cents, same as /cart.js —
     verified live). Cached per variant_id so nothing is fetched twice, and
     lookups never block rendering: rows render first, MRP fills in. */
  var mrpCache = {};
  var mrpFetching = {};
  var mrpFailed = {};

  function variantCompareAt(it) {
    var vid = String(it.variant_id);

    if (mrpCache[vid] !== undefined) {
      return mrpCache[vid];
    }

    /* Some responses do expose the value directly — trust it when present. */
    if (typeof it.compare_at_price === 'number' && it.compare_at_price > 0) {
      mrpCache[vid] = it.compare_at_price;
      return it.compare_at_price;
    }

    return undefined;
  }

  function loadMRP() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var wanted = {};

    curCart.items.forEach(function (it) {
      if (it.synthetic || !it.handle) return;

      var vid = String(it.variant_id);

      if (mrpCache[vid] !== undefined) return;

      if (typeof it.compare_at_price === 'number' && it.compare_at_price > 0) {
        mrpCache[vid] = it.compare_at_price;
        return;
      }

      if (mrpFailed[it.handle] && Date.now() - mrpFailed[it.handle] < 30000) return;

      wanted[it.handle] = true;
    });

    Object.keys(wanted).forEach(function (h) {
      if (mrpFetching[h]) return;

      mrpFetching[h] = true;

      fetch(root + 'products/' + encodeURIComponent(h) + '.js', {
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Product lookup failed');
          return r.json();
        })
        .then(function (p) {
          var learned = false;

          ((p && p.variants) || []).forEach(function (v) {
            var vid = String(v.id);

            if (mrpCache[vid] !== undefined) return;

            mrpCache[vid] =
              (typeof v.compare_at_price === 'number' && v.compare_at_price > 0)
                ? v.compare_at_price
                : 0;

            learned = true;
          });

          return learned;
        })
        .catch(function () {
          mrpFailed[h] = Date.now();
          return false;
        })
        .then(function (learned) {
          delete mrpFetching[h];

          if (learned) {
            applyOptimistic();
          }
        });
    });
  }

  /* ---------- Optimistic upsell ADD ----------
     A temporary line built from the upsell card's own Shopify price snapshot
     so the row appears on click. No MRP is shown on it (MRP comes only from
     real cart line data) and it is replaced by the authoritative /cart/add.js
     response immediately after. */
  function injectSyntheticLine(ups) {
    var vid = String(ups.id);

    /* Product already has a real line in the cart — bump its quantity
       optimistically instead of adding a second row for the same item. */
    for (var i = 0; i < curCart.items.length; i++) {
      var existing = curCart.items[i];
      if (!existing.synthetic && String(existing.variant_id) === vid) {
        var existingIdentity = lineIdentity(existing);
        mergedBumpIdentities[existingIdentity] = true;
        desiredQty[existingIdentity] = effectiveQty(existing) + 1;
        return;
      }
    }

    var syntheticKey = 'pending-add-' + ups.id;
    var identity = 'pending::' + vid;
    if (lineOrder[identity] === undefined) lineOrder[identity] = lineOrderSeq++;
    pendingOrderByVariant[vid] = lineOrder[identity];

    curCart.items.push({
      key: syntheticKey,
      variant_id: ups.id,
      product_title: ups.name,
      variant_title: ups.meta || '',
      quantity: 1,
      price: ups.price,
      final_price: ups.price,
      final_line_price: ups.price,
      original_line_price: ups.price,
      compare_at_price: null,
      image: ups.img || null,
      synthetic: true,
      _mirava_identity: identity
    });
  }

  function removeSyntheticLines() {
    curCart.items = curCart.items.filter(function (it) { return !it.synthetic; });
    Object.keys(mergedBumpIdentities).forEach(function (id) { delete desiredQty[id]; });
    mergedBumpIdentities = {};
  }

  function snapshotLine(it) {
    if (!it || it.synthetic) return;
    var spa = it.selling_plan_allocation;
    lineSnapshots[lineIdentity(it)] = {
      variant_id: it.variant_id,
      properties: normalizeProperties(it.properties),
      selling_plan: spa && spa.selling_plan ? spa.selling_plan.id : null,
      product_title: it.product_title || it.title || 'Product'
    };
  }

  function effectiveQty(it) {
    var id = it.synthetic ? ('pending::' + String(it.variant_id)) : lineIdentity(it);
    if (desiredQty[id] !== undefined) return desiredQty[id];
    return it.quantity;
  }

  function effectiveFinalLinePrice(it) {
    var q = effectiveQty(it);
    var unit = it.quantity > 0 ? it.final_line_price / it.quantity : (typeof it.final_price === 'number' ? it.final_price : 0);
    return Math.round(unit * q);
  }

  function effectiveItemCount() {
    var c = 0;
    curCart.items.forEach(function (it) { c += Math.max(0, effectiveQty(it)); });
    return c;
  }

  function effectiveTotalPrice() {
    if (effectiveItemCount() === 0) return 0;
    var t = otherTotal;
    curCart.items.forEach(function (it) { t += effectiveFinalLinePrice(it); });
    return Math.max(0, t);
  }

  function effectiveTotalDiscount() {
    if (effectiveItemCount() === 0) return 0;
    var d = otherDiscount;
    curCart.items.forEach(function (it) {
      if (it.synthetic || it.quantity <= 0) return;
      var unitOrig = it.original_line_price / it.quantity;
      var unitFinal = it.final_line_price / it.quantity;
      if (unitOrig > unitFinal) d += (unitOrig - unitFinal) * effectiveQty(it);
    });
    return Math.max(0, Math.round(d));
  }

  /* Round 6: cart-wide MRP total mirroring the per-row strike math
     (variantCompareAt via mrpCache) so the total-row stack, savings badge
     and item rows all agree. Lines without a known MRP contribute their
     final line price. */
  function cartMrpTotal() {
    var t = 0;
    curCart.items.forEach(function (it) {
      if (it.synthetic || (it.quantity || 0) <= 0) return;
      var qty = effectiveQty(it);
      if (qty <= 0) return;
      var unitFinal =
        typeof it.final_price === 'number'
          ? it.final_price
          : Math.round(
              (it.final_line_price || 0) / Math.max(it.quantity || 1, 1)
            );
      var unitCompare = variantCompareAt(it);
      var mrp =
        unitCompare !== undefined && unitCompare > unitFinal
          ? unitCompare * qty
          : 0;
      var lineFinal = effectiveFinalLinePrice(it);
      t += mrp > lineFinal ? mrp : lineFinal;
    });
    return t;
  }

  function applyOptimistic() {
    renderItems();
    renderUpsell();
    render();
    updateHeaderBubble();
  }

  function queueChange(key, next) {
    var it = findItem(key);
    if (!it || it.synthetic) return;
    var id = lineIdentity(it);
    var base = effectiveQty(it);
    var target = next === 'inc' ? base + 1 : next === 'dec' ? base - 1 : parseInt(next, 10);
    if (isNaN(target)) return;
    target = Math.max(0, target);
    if (target === base) return;
    snapshotLine(it);
    desiredQty[id] = target;
    applyOptimistic();
    pumpMutations();
  }

  /* Global serialization is intentional: every change.js response is a complete cart snapshot. */
  function finishMutation() {
    inFlightMutation = false;
    applyOptimistic();

    /* A /cart.js read requested while a mutation was in flight may have
       observed the old cart. Never let that read become the final state.
       Re-fetch once the mutation has settled, then continue queued changes. */
    if (refreshQueued) {
      refreshQueued = false;
      refreshCart(true)
        .catch(function () { showCartError(); })
        .then(function () { pumpMutations(); });
      return;
    }

    pumpMutations();
  }

  function pumpMutations() {
    if (inFlightMutation) return;
    var ids = Object.keys(desiredQty);
    if (!ids.length) return;

    var id = ids[0];
    var target = desiredQty[id];
    var it = findItemByIdentity(id);

    if (!it) {
      if (target <= 0) { delete desiredQty[id]; pumpMutations(); return; }
      var snap = lineSnapshots[id];
      if (!snap || !snap.variant_id) {
        delete desiredQty[id];
        applyOptimistic();
        showCartError();
        pumpMutations();
        return;
      }

      inFlightMutation = true;
      var payload = { id: snap.variant_id, quantity: target };
      if (snap.properties && Object.keys(snap.properties).length) payload.properties = snap.properties;
      if (snap.selling_plan) payload.selling_plan = snap.selling_plan;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [payload] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().catch(function () { return null; }).then(function (body) {
            var e = new Error('Cart restore failed');
            e.detail = body && (body.description || body.message);
            throw e;
          });
          return r.json();
        })
        .then(function () {
          /* The add response is not used to build totals manually. Clear the
             mutation lock first, then obtain a full authoritative cart. */
          inFlightMutation = false;
          return refreshCart(true);
        })
        .then(function () {
          applyOptimistic();
          pumpMutations();
        })
        .catch(function (err) {
          inFlightMutation = false;
          delete desiredQty[id];
          if (lastServerCart) applyCart(lastServerCart);
          showCartError(err && err.detail ? err.detail : undefined);
          applyOptimistic();
          pumpMutations();
        });
      return;
    }

    if (target === it.quantity) {
      delete desiredQty[id];
      applyOptimistic();
      pumpMutations();
      return;
    }

    inFlightMutation = true;
    var sentTarget = target;
    var seq = nextMutationSeq();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: it.key, quantity: target })
    })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return null; }).then(function (body) {
          var e = new Error('Cart update failed');
          e.rejected = r.status === 422;
          e.detail = body && (body.description || body.message);
          throw e;
        });
        return r.json();
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count === 'undefined') throw new Error('Invalid cart response');
        /* change.js returns the complete cart; it is authoritative and must
           render even though the mutation is still marked in flight. */
        tryApplyCart(seq, cart);
        if (desiredQty[id] === sentTarget) delete desiredQty[id];
      })
      .catch(function (err) {
        if (lastServerCart) applyCart(lastServerCart);
        showCartError(err && err.rejected && err.detail ? err.detail : DEFAULT_CART_ERROR);
      })
      .then(function () {
        finishMutation();
      });
  }

  function renderItems() {
    if (!itemsEl) return;

    itemsEl.innerHTML = '';

    var effCount = effectiveItemCount();

    if (curCart.items.length === 0 || effCount === 0) {
      itemsEl.style.display = 'none';

      if (emptyEl) {
        emptyEl.hidden = false;
      }

      return;
    }

    itemsEl.style.display = 'flex';

    if (emptyEl) {
      emptyEl.hidden = true;
    }

    /* Render in the drawer's own stable order — immune to server re-sorts. */
    var ordered = curCart.items.slice().sort(function (a, b) {
      var oa = ensureLineOrder(
        a.synthetic ? ('pending::' + String(a.variant_id)) : lineIdentity(a),
        a.variant_id
      );

      var ob = ensureLineOrder(
        b.synthetic ? ('pending::' + String(b.variant_id)) : lineIdentity(b),
        b.variant_id
      );

      return oa - ob;
    });

    ordered.forEach(function (it) {
      /* A line queued for removal disappears immediately — no ghost row. */
      if (effectiveQty(it) === 0) return;

      var svg =
        '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.5">' +
        '<rect x="14" y="18" width="20" height="22" rx="4"/>' +
        '</svg>';

      var imgHtml = it.image
        ? '<img src="' + withParam(it.image, 'width=120') + '" alt="" loading="lazy">'
        : svg;

      var row = document.createElement('div');

      row.className = 'item';
      row.setAttribute('data-key', it.key);

      /* MRP = the compare-at price of THIS exact product variant, resolved
         from Shopify product data — never MIRAVA_UPSELL, never invented.
         Rendered only when a real higher compare-at is known. */
      var qty = effectiveQty(it);

      var unitFinal =
        typeof it.final_price === 'number'
          ? it.final_price
          : Math.round(
              (it.final_line_price || 0) /
              Math.max(it.quantity || 1, 1)
            );

      var unitCompare = variantCompareAt(it);

      var mrp =
        (unitCompare !== undefined && unitCompare > unitFinal)
          ? unitCompare * qty
          : 0;

      if (mrp <= effectiveFinalLinePrice(it)) {
        mrp = 0;
      }

      row.innerHTML =
        '<div class="thumb">' +
          imgHtml +
        '</div>' +

        '<div class="main">' +

          '<div class="top">' +

            '<div>' +
              '<div class="name">' +
                (it.product_title || it.title || 'Product') +
              '</div>' +

              '<div class="meta">' +
                (function () {
                  var metaText =
                    it.variant_title &&
                    it.variant_title !== 'Default Title'
                      ? it.variant_title
                      : '';
                  var handleMatch = (it.url || '').match(
                    /\/products\/([^\/?]+)/
                  );
                  var itemSize =
                    window.MIRAVA_ITEM_SIZES &&
                    handleMatch &&
                    window.MIRAVA_ITEM_SIZES[handleMatch[1]];
                  if (itemSize) {
                    metaText = metaText
                      ? metaText + ' \u00B7 ' + itemSize
                      : itemSize;
                  }
                  if (it.properties && (it.properties['Gift message'] || it.properties['To'])) {
                    metaText = metaText
                      ? metaText + ' \u00B7 \uD83C\uDF81 Gift message added'
                      : '\uD83C\uDF81 Gift message added';
                  }
                  return metaText;
                })() +
              '</div>' +

            '</div>' +

            '<div>' +
              '<div class="price" data-line-price>' +
                money(effectiveFinalLinePrice(it)) +
              '</div>' +

              (
                mrp > 0
                  ? '<div class="mrp">' + money(mrp) + '</div>'
                  : ''
              ) +

            '</div>' +

          '</div>' +

          '<div class="bottom">' +

            '<button class="remove" data-key="' +
  it.key +
  '" data-action="remove" aria-label="Remove">' +
  '<svg class="remove-icon" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path class="remove-icon-bottom" d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
  '<path class="remove-icon-top" d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>' +
  '</button>' +

            '<div class="qty">' +

              '<button data-key="' +
                it.key +
                '" data-action="dec" aria-label="Decrease quantity">' +
                '\u2212' +
              '</button>' +

              '<span data-qty-value>' +
                qty +
              '</span>' +

              '<button data-key="' +
                it.key +
                '" data-action="inc" aria-label="Increase quantity">' +
                '+' +
              '</button>' +

            '</div>' +

          '</div>' +

        '</div>';

      itemsEl.appendChild(row);
    });

    /* Round 4: per-item busy state while this line's mutation is in flight. */
    ordered.forEach(function (it) {
      if (desiredQty[lineIdentity(it)] === undefined) return;
      var busyRow = itemsEl.querySelector(
        '.item[data-key="' + it.key + '"]'
      );
      if (busyRow) busyRow.classList.add('is-busy');
    });

    /* Kick off any pending variant lookups — non-blocking, cache-guarded. */
    loadMRP();
  }

  function renderUpsell() {
    if (!upsellEl) return;

    upsellEl.innerHTML = '';

    var shown = 0;

    UPSELL.forEach(function (p) {
      if (inCart(p.id)) return;
      if (pendingAddIds[p.id]) return;

      var card = document.createElement('article');

      card.className = 'rec';
      card.setAttribute('data-add-one', p.id);

      /* Real MRP only — never render the same price twice. */
      var hasMrp =
        typeof p.mrp === 'number' &&
        p.mrp > p.price;

      /* Real Shopify product thumbnail; SVG motif only as last-resort fallback. */
      var rimgInner = p.img
        ? '<img src="' +
            p.img +
            '" alt="' +
            p.name +
            '" loading="lazy" width="46" height="54">'
        : p.svg;

      card.innerHTML =
        '<div class="rimg">' +
          rimgInner +
        '</div>' +

        '<div>' +

          '<div class="rname">' +
            p.name +
          '</div>' +

          '<div class="rprice">' +
            fmtINR(p.price / 100) +
            (
              hasMrp
                ? ' <span class="rmrp">' +
                    fmtINR(p.mrp / 100) +
                  '</span>'
                : ''
            ) +
          '</div>' +

          '<button class="add" data-action="add">Add</button>' +

        '</div>';

      upsellEl.appendChild(card);

      shown++;
    });

    /* Nothing to recommend — collapse the whole section. */
    if (upsellSection) {
      upsellSection.hidden = shown === 0;
    }

    /* Round 12v2: the row itself is the slider — mouse drag scrolls it
       (touch swipes natively). Bound once; the container persists across
       re-renders. */
    bindUpsellDrag();
  }

  function bindUpsellDrag() {
    if (!upsellEl || upsellEl.__dragBound) return;
    upsellEl.__dragBound = true;

    var down = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    upsellEl.addEventListener(
      'pointerdown',
      function (e) {
        /* Touch already scrolls natively — drag is for mouse. */
        if (e.pointerType !== 'mouse') return;
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = upsellEl.scrollLeft;
        upsellEl.classList.add('is-dragging');
      }
    );

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      upsellEl.scrollLeft = startScroll - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      upsellEl.classList.remove('is-dragging');
    });

    /* A drag must not fire the card's Add button on release. */
    upsellEl.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }
  /* "Any 3 for ₹999" nudge: counts eligible routine items in the cart.
     The real price is always applied by the Shopify discount. */
  var comboEl = drawer.querySelector('[data-combo-nudge]');
  var comboMsgEl = drawer.querySelector('[data-combo-msg]');
  function renderComboNudge(isEmpty) {
    if (!comboEl || !CFG.combo) return;
    var need = CFG.combo.qty || 3, handles = CFG.combo.handles || [], n = 0;
    if (curCart && !isEmpty) {
      curCart.items.forEach(function (it) {
        var h = it.handle || ((it.url || '').match(/\/products\/([^\/?]+)/) || [])[1];
        if (h && handles.indexOf(h) > -1) n += parseInt(it.quantity, 10) || 0;
      });
    }
    if (!n) { comboEl.hidden = true; return; }
    var price = '\u20B9' + CFG.combo.price, rem = n % need, kits = Math.floor(n / need), html;
    if (rem === 0) {
      html = '<b>' + (kits > 1 ? kits + ' combos' : 'Any ' + need + ' for ' + price) + ' applied \u2713</b>';
      comboEl.classList.add('is-done');
    } else {
      var left = need - rem;
      html = 'Add <b>' + left + ' more</b> \u2014 get any ' + need + ' for <b>' + price + '</b>';
      if (exitBagActive()) html += ' <span class="combo-nudge__bag">+ free jute bag \uD83C\uDF81</span>';
      comboEl.classList.remove('is-done');
    }
    comboMsgEl.innerHTML = html;
    comboEl.hidden = false;
  }

  /* ===== V2: exit-popup jute bag =====
     Popup claim sets localStorage mvExitBag + attaches the discount code.
     Here: bag line is added once the cart has `combo.qty` eligible items and
     removed if it drops below; never more than 1. The price is made ₹0 by the
     Shopify discount code (Buy X get Y), not by the theme. */
  var exitBagBusy = false, exitBagFailed = false, exitBagTries = 0;
  function exitBagActive() {
    if (!CFG.exitBag) return false;
    try { return !!localStorage.getItem('mvExitBag'); } catch (e) { return false; }
  }
  function comboCount() {
    var handles = (CFG.combo && CFG.combo.handles) || [], n = 0;
    (curCart && curCart.items || []).forEach(function (it) {
      var h = it.handle || ((it.url || '').match(/\/products\/([^\/?]+)/) || [])[1];
      if (h && handles.indexOf(h) > -1) n += parseInt(it.quantity, 10) || 0;
    });
    return n;
  }
  function exitBagLine() {
    if (!CFG.exitBag || !curCart) return null;
    var id = String(CFG.exitBag.id), items = curCart.items || [];
    for (var i = 0; i < items.length; i++) if (String(items[i].variant_id) === id) return items[i];
    return null;
  }
  function renderExitBag(isEmpty) {
    if (!CFG.exitBag || !curCart || exitBagBusy) return;
    var line = exitBagLine();
    if (line && itemsEl) {
      var b = itemsEl.querySelector('[data-key="' + line.key + '"]');
      var row = b ? b.closest('.item') : null;
      if (row && !row.classList.contains('is-gift')) {
        row.classList.add('is-gift');
        var nm = row.querySelector('.name');
        var tg = document.createElement('span');
        tg.className = 'gift-tag'; tg.textContent = 'FREE GIFT';
        if (nm && nm.parentNode) nm.parentNode.insertBefore(tg, nm.nextSibling);
      }
    }
    if (!exitBagActive()) return;
    var need = (CFG.combo && CFG.combo.qty) || 3;
    var eligible = !isEmpty && comboCount() >= need;
    if (line && !eligible) { queueChange(line.key, 0); return; }
    if (line && line.quantity > 1) { queueChange(line.key, 1); return; }
    if (!line && eligible && !exitBagFailed && exitBagTries < 2) {
      exitBagTries++;
      exitBagBusy = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: CFG.exitBag.id, quantity: 1, properties: { '_source': 'exit-popup' } })
      }).then(function (r) {
        if (!r.ok) { exitBagFailed = true; throw new Error('bag add failed'); }
        /* code dobara attach (customer ne beech me hata diya ho to) */
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: CFG.exitBag.code })
        });
      }).catch(function () {}).then(function () {
        exitBagBusy = false;
        refreshCart(true).catch(function () {});
      });
    }
  }

  function setGiftBadge(show) {
    if (giftBadge) {
      giftBadge.hidden = !show;
    }
  }

  function milestoneSteps(cartDone, shipDone, giftDone) {
    if (!stepsEl) return;

    var s = stepsEl.querySelectorAll('.step');
    var states = [
      !!cartDone,
      !!shipDone,
      !!giftDone
    ];

    for (var i = 0; i < s.length; i++) {
      var was = milestoneState[i];

      var cls = 'step';

      if (s[i].classList.contains('ms-gift')) {
        cls += ' ms-gift';
      }

      /* Preserve an in-progress celebration burst class across re-renders —
         otherwise ANY cart action fired mid-animation (e.g. a quantity
         click on a different line) wipes className and jump-cuts the
         0.72s pulse instead of letting it finish. */
      if (s[i].classList.contains('just-reached')) {
        cls += ' just-reached';
      }

      if (i === 0) {
        cls += ' ' + (
          states[0]
            ? 'reached'
            : 'active'
        );
      }

      if (i === 1) {
        cls += ' ' + (
          states[1]
            ? 'reached'
            : (states[0] ? 'active' : '')
        );
      }

      if (i === 2) {
        cls += ' ' + (
          states[2]
            ? 'reached'
            : (states[1] ? 'active' : '')
        );
      }

      s[i].className = cls;

      if (
        milestoneReady &&
        states[i] &&
        !was
      ) {
        celebrate(s[i]);
      }
    }

    milestoneState = states;
  }

  /* Birthday-pop confetti burst — canvas particles exploding from the
     milestone dot. Decorative only: pointer-events none, auto-cleans after
     the blast, respects reduced-motion, and every failure is swallowed so
     cart flows are never affected. */
  function confettiBurst(originEl) {
    try {
      if (!originEl || !drawer) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var drect = drawer.getBoundingClientRect();
      var orect = originEl.querySelector('.dot') || originEl;
      var r = orect.getBoundingClientRect();
      if (r.bottom < drect.top || r.top > drect.bottom) return;
      var ox = r.left - drect.left + r.width / 2;
      var oy = r.top - drect.top + r.height / 2;

      var canvas = document.createElement('canvas');
      var W = Math.max(1, Math.round(drect.width));
      var H = Math.max(1, Math.round(drect.height));
      canvas.width = W;
      canvas.height = H;
      canvas.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:60;';
      drawer.appendChild(canvas);

      var COLORS = ['#018382', '#5fc9c7', '#FFD54A', '#ffffff', '#e8833a', '#b42318'];
      var N = 90;
      var parts = [];
      for (var i = 0; i < N; i++) {
        var ang = Math.random() * Math.PI * 2;
        var spd = 3 + Math.random() * 7;
        parts.push({
          x: ox,
          y: oy,
          vx: Math.cos(ang) * spd,
          vy: Math.sin(ang) * spd - 4.5,
          g: 0.16 + Math.random() * 0.08,
          s: 3 + Math.random() * 4,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.35,
          c: COLORS[(Math.random() * COLORS.length) | 0],
          life: 0,
          max: 70 + Math.random() * 30
        });
      }

      var ctx = canvas.getContext('2d');
      var raf = null;

      function cleanup() {
        if (raf) window.cancelAnimationFrame(raf);
        if (canvas.parentNode) canvas.remove();
      }

      function tick() {
        ctx.clearRect(0, 0, W, H);
        var alive = 0;
        for (var k = 0; k < parts.length; k++) {
          var p = parts[k];
          p.life++;
          if (p.life > p.max) continue;
          alive++;
          p.vy += p.g;
          p.x += p.vx;
          p.y += p.vy;
          p.vx *= 0.985;
          p.rot += p.vr;
          var alpha =
            1 - Math.max(0, (p.life - p.max * 0.55) / (p.max * 0.45));
          ctx.save();
          ctx.globalAlpha = Math.max(0, alpha);
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.c;
          ctx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2);
          ctx.restore();
        }
        if (alive > 0) raf = window.requestAnimationFrame(tick);
        else cleanup();
      }

      raf = window.requestAnimationFrame(tick);
      window.setTimeout(cleanup, 2600);
    } catch (e) {
      /* decorative only — never surface */
    }
  }

  function celebrate(el) {
    el.classList.remove('just-reached');

    void el.offsetWidth;

    el.classList.add('just-reached');

    confettiBurst(el);

    var burst = document.createElement('span');

    burst.className = 'milestone-celebrate';

    burst.style.left =
      (el.getAttribute('data-pos') || '0') + '%';

    burst.style.top = '50%';

    var pieces = [
      ['-18px', '-20px', '-25deg'],
      ['-6px', '-27px', '20deg'],
      ['10px', '-22px', '65deg'],
      ['20px', '-10px', '110deg'],
      ['17px', '8px', '150deg'],
      ['4px', '20px', '200deg']
    ];

    pieces.forEach(function (p) {
      var c = document.createElement('i');

      c.className = 'milestone-confetti';

      c.style.setProperty('--x', p[0]);
      c.style.setProperty('--y', p[1]);
      c.style.setProperty('--r', p[2]);

      burst.appendChild(c);
    });

    stepsEl.appendChild(burst);

    setTimeout(function () {
      burst.remove();
    }, 900);
  }

  function render() {
    var effCount = effectiveItemCount();
    var effTotal = effectiveTotalPrice();

    if (countEl) {
      countEl.textContent =
        '(' +
        effCount +
        (effCount === 1 ? ' item' : ' items') +
        ')';
    }

    var mrpStrike = curCart ? cartMrpTotal() : 0;

    /* Round 14: "You're saving" truthiness — during optimistic quantity
       changes otherTotal still holds the PREVIOUS fetch's coupon, so
       effTotal (and the badge built on it) showed a stale amount. The
       applied code's configured tier lets us predict the coupon for the
       CURRENT optimistic subtotal instead. */
    var linesSum = 0;
    var couponNew = 0;
    var couponPredicted = false;
    if (curCart) {
      curCart.items.forEach(function (it) {
        if (it.synthetic) return;
        linesSum += effectiveFinalLinePrice(it);
      });

      var appliedEntry =
        curCart.discount_codes && curCart.discount_codes.length
          ? curCart.discount_codes[0]
          : null;

      if (appliedEntry && appliedEntry.code) {
        var matchedTier = null;
        (CFG.coupons || []).forEach(function (c) {
          if (
            c.code &&
            String(c.code).toUpperCase() ===
              String(appliedEntry.code).toUpperCase()
          ) {
            matchedTier = c;
          }
        });

        if (matchedTier) {
          couponPredicted = true;
          couponNew =
            linesSum >= matchedTier.min * 100
              ? Math.round((linesSum * matchedTier.pct) / 100)
              : 0;
        } else if (couponApplied(appliedEntry.code)) {
          /* Manual/unconfigured code — no tier to predict from; keep the
             server-side amount we already have. */
          couponNew = Math.max(0, -otherTotal);
        }
      }
    }

    var effTotalDisplay = couponPredicted
      ? Math.max(0, linesSum - couponNew)
      : effTotal;

    if (totalEl) {
      totalEl.textContent = money(effTotalDisplay);
    }

    /* Round 6: MRP strikethrough stacked above the final total (prototype
       price-stack). Hidden when MRP equals the total (no savings to prove);
       fills in when the async mrpCache lookup lands and re-renders. */
    if (totalMrpEl) {
      totalMrpEl.textContent =
        mrpStrike > effTotalDisplay ? money(mrpStrike) : '';
    }

    var isEmpty = effCount === 0;

    /* Empty cart: checkout must not stay actionable. */
    if (checkoutEl) {
      checkoutEl.classList.toggle(
        'is-disabled',
        isEmpty
      );

      checkoutEl.setAttribute(
        'aria-disabled',
        isEmpty ? 'true' : 'false'
      );

      if (isEmpty) {
        checkoutEl.setAttribute('tabindex', '-1');
      } else {
        checkoutEl.removeAttribute('tabindex');
      }
    }

    if (discSection) {
      discSection.hidden = isEmpty;
    }

    var subtotalRs = effTotal / 100;

    /* Round 6/14: badge savings = MRP total minus the DISPLAYED total —
       effTotalDisplay already carries the predicted coupon during
       optimistic windows, so the badge is always the real number. */
    var totalDiscount = Math.max(0, mrpStrike - effTotalDisplay);

    if (savingEl) {
      savingEl.textContent =
        totalDiscount >= 100
          ? 'You\u2019re saving ' +
            fmtINR(totalDiscount / 100) +
            ' on this order'
          : '';
    }

    renderCoupons();
    renderTotalDetails();
    tagGiftItem();
    renderGiftState();

    var milestoneTotal = subtotalRs;

    renderComboNudge(isEmpty);
    renderExitBag(isEmpty);

    /* No free-gift product configured: show only Cart -> Free shipping
       (never promise a gift that does not exist). */
    if (!CFG.gift) {
      drawer.classList.add('no-gift');
      if (isEmpty) {
        if (fillEl) fillEl.style.width = '0';
        if (msgEl) msgEl.textContent = 'Your cart is waiting for you';
        milestoneSteps(false, false, false);
      } else if (milestoneTotal < FREE_SHIP) {
        if (fillEl) fillEl.style.width = Math.round(25 + milestoneTotal / FREE_SHIP * 50) + '%';
        if (msgEl) msgEl.innerHTML = 'Add <b>' + fmtINR(FREE_SHIP - milestoneTotal) + '</b> more to unlock <b>free shipping</b>';
        milestoneSteps(true, false, false);
      } else {
        if (fillEl) fillEl.style.width = '100%';
        if (msgEl) msgEl.innerHTML = '<b>Free shipping unlocked</b> \u2014 enjoy';
        milestoneSteps(true, true, false);
      }
      setGiftBadge(false);
      milestoneReady = true;
      return;
    }
    drawer.classList.remove('no-gift');

    /* Use the same optimistic "isEmpty" the rest of the drawer uses (not
       curCart.items.length) — otherwise a cart whose only lines are queued
       for removal still shows the "add ₹X more" message instead of the
       empty-cart message, even though the items list itself already shows
       empty state. */
    if (isEmpty) {
      if (fillEl) {
        fillEl.style.width = '0';
      }

      if (msgEl) {
        msgEl.textContent =
          'Your cart is waiting for you';
      }

      setGiftBadge(false);
      milestoneSteps(false, false, false);

    } else if (milestoneTotal < FREE_SHIP) {
      if (fillEl) {
        fillEl.style.width =
          Math.round(
            milestoneTotal / FREE_SHIP * 50
          ) + '%';
      }

      if (msgEl) {
        msgEl.innerHTML =
          'Add <b>' +
          fmtINR(FREE_SHIP - milestoneTotal) +
          '</b> more to unlock <b>free shipping</b>';
      }

      setGiftBadge(false);
      milestoneSteps(true, false, false);

    } else if (milestoneTotal < FREE_GIFT) {
      if (fillEl) {
        fillEl.style.width =
          Math.round(
            50 +
            (milestoneTotal - FREE_SHIP) /
            (FREE_GIFT - FREE_SHIP) *
            50
          ) + '%';
      }

      if (msgEl) {
        msgEl.innerHTML =
          'Free shipping unlocked! Add <b>' +
          fmtINR(FREE_GIFT - milestoneTotal) +
          '</b> more for a <b>free gift</b>';
      }

      setGiftBadge(false);
      milestoneSteps(true, true, false);

    } else {
      if (fillEl) {
        fillEl.style.width = '100%';
      }

      if (msgEl) {
        msgEl.innerHTML =
          '<b>Free shipping + free gift unlocked</b> \u2014 enjoy';
      }

      /* Only now has the gift actually been earned — this is the one
         state the FREE GIFT pill (built in the markup/CSS but never
         wired up) should show. */
      setGiftBadge(true);
      milestoneSteps(true, true, true);
    }

    milestoneReady = true;
  }

  function updateHeaderBubble() {
    var count = effectiveItemCount() || 0;

    document
      .querySelectorAll('.cart-count-bubble')
      .forEach(function (el) {
        el.textContent = String(count);
      });

    document
      .querySelectorAll('.header-actions__cart-icon')
      .forEach(function (el) {
        el.classList.toggle(
          'header-actions__cart-icon--has-cart',
          count > 0
        );
      });
  }

  /* NOTE: no premature updateHeaderBubble() call here anymore — calling it
     at parse time forced the header bubble to 0 before the very first
     /cart.js response landed, causing a visible flash on any page where the
     bubble was already server-rendered with the real count. The first
     refreshCart() at the bottom of this file calls applyCart(), which calls
     updateHeaderBubble() once with real data — that's the only call needed. */

  function setLoading(on) {
    drawer.classList.toggle(
      'is-loading',
      !!on
    );

    if (on) {
      drawer.setAttribute(
        'aria-busy',
        'true'
      );
    } else {
      drawer.removeAttribute('aria-busy');
    }
  }

  function showCartError(msg) {
    if (!errorEl) return;

    errorEl.textContent =
      msg || DEFAULT_CART_ERROR;

    errorEl.hidden = false;

    if (errorTimer) {
      clearTimeout(errorTimer);
    }

    errorTimer = setTimeout(function () {
      errorTimer = null;
      clearCartError();
    }, 6000);
  }

  function clearCartError() {
    if (errorTimer) {
      clearTimeout(errorTimer);
      errorTimer = null;
    }

    if (errorEl) {
      errorEl.textContent =
        DEFAULT_CART_ERROR;

      errorEl.hidden = true;
    }
  }

  /* Authoritative render: curCart is always a Shopify-provided cart object —
     either a /cart.js response or the full cart returned by /cart/change.js.
     lastServerCart keeps an untouched copy for revert-on-failure. Still-pending
     optimistic overrides (by stable line key) are merged onto the fresh data,
     and overrides the server has already confirmed are dropped.
     Only ever called through tryApplyCart() so out-of-order responses can't
     clobber a newer state — never call this directly from a network callback. */
  function applyCart(cart) {
    removeSyntheticLines();
    curCart = cart || { items: [], total_price: 0, item_count: 0 };
    lastServerCart = JSON.parse(JSON.stringify(curCart));

    var lineSum = 0;
    var lineDisc = 0;
    curCart.items.forEach(function (it) {
      snapshotLine(it);
      ensureLineOrder(lineIdentity(it), it.variant_id);
      lineSum += it.final_line_price || 0;
      lineDisc += Math.max(0, (it.original_line_price || it.final_line_price || 0) - (it.final_line_price || 0));
    });

    otherTotal = (curCart.total_price || 0) - lineSum;
    otherDiscount = Math.max(0, (curCart.total_discount || 0) - lineDisc);

    Object.keys(desiredQty).forEach(function (id) {
      var item = findItemByIdentity(id);
      if (item && item.quantity === desiredQty[id]) delete desiredQty[id];
    });

    renderItems();
    renderUpsell();
    render();
    updateHeaderBubble();
    clearCartError();
  }

  /* /cart.js is the source of truth for background/open refreshes. Every
     response is applied through tryApplyCart(), which discards it if a
     newer mutation (from a quantity change or an add) has already landed.
     Rejects on failure — callers own their error UX. Pass quiet=true for
     background refreshes that must not dim the drawer. */
  function refreshCart(quiet) {
    var seq = nextMutationSeq();
    if (inFlightMutation) refreshQueued = true;
    if (!quiet) setLoading(true);
    var request = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart refresh failed');
        return r.json();
      })
      .then(function (cart) {
        /* If a mutation was active when this read was requested, the response
           may be an older snapshot. It is deliberately discarded; the queued
           refresh in finishMutation() will fetch after the write has settled. */
        if (!inFlightMutation && seq === cartSeq && !refreshQueued) {
          tryApplyCart(seq, cart);
        }
        return cart;
      })
      .then(function (cart) {
        if (!quiet && seq === cartSeq && !inFlightMutation) setLoading(false);
        return cart;
      }, function (err) {
        if (!quiet && seq === cartSeq && !inFlightMutation) setLoading(false);
        throw err;
      });
    return request;
  }

  window.MiravaCartRefresh = refreshCart;
  /*
   * MIRAVA — External Add-to-Cart bridge (optimistic)
   *
   * Homepage / Featured Products / Routine add buttons use this.
   *
   * /cart/add.js returns added line items only — NOT a full cart. The
   * drawer opens instantly with a synthetic line built from the caller's
   * card info; the authoritative /cart.js reconcile runs after the POST
   * settles. inFlightMutation is held for the whole POST so any /cart.js
   * read that races it (open()'s own refresh) is discarded by the
   * existing guards; refreshQueued is reset before the final reconcile
   * so that refresh is not silently dropped.
   */
  function miravaExternalAddToCart(variantId, quantity, info) {
    variantId = String(variantId || '').trim();
    quantity = Math.max(1, parseInt(quantity, 10) || 1);
    info = info || {};

    if (!variantId) {
      return Promise.reject(
        new Error('Missing variant id')
      );
    }

    /* Same product already adding — join it silently. */
    if (pendingAddIds[variantId]) {
      return Promise.resolve();
    }
    pendingAddIds[variantId] = true;

    inFlightMutation = true;

    injectSyntheticLine({
      id: variantId,
      name: info.name || '',
      meta: info.meta || '',
      price: info.price || 0,
      img: info.img || null
    });
    applyOptimistic();
    open();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) {
            throw json;
          }

          return json;
        });
      })
      .catch(function (error) {
        /* Add failed — drop the optimistic line, restore the last
           authoritative cart, surface the reason. */
        delete pendingAddIds[variantId];
        removeSyntheticLines();
        if (lastServerCart) applyCart(lastServerCart);
        inFlightMutation = false;
        refreshQueued = false;
        setLoading(false);
        applyOptimistic();
        showCartError(error && (error.description || error.message));
        throw error;
      })
      .then(function (json) {
        delete pendingAddIds[variantId];
        inFlightMutation = false;
        refreshQueued = false;
        /* POST has landed — the optimistic row is now backed by the
           server. Drop the dim/loading state immediately and reconcile
           quietly: the authoritative /cart.js applies invisibly when it
           arrives (it matches the optimistic row). */
        setLoading(false);
        emitAdded([{ id: variantId, quantity: quantity }], json);
        return refreshCart(true).then(function () {
          return json;
        });
      });
  }

  /* One shared signal after every confirmed add (tracking/analytics hook). */
  function emitAdded(items, json) {
    try {
      document.dispatchEvent(new CustomEvent('mirava:cart:added', {
        detail: { items: items, response: json || null }
      }));
    } catch (e) {}
  }

  /* Multi-item add (routine / bundle / "add all"): ONE request, then the
     drawer shows the authoritative cart. Errors surface in the drawer. */
  function miravaAddItems(items) {
    items = (items || []).filter(function (it) { return it && it.id; }).map(function (it) {
      var row = { id: String(it.id), quantity: Math.max(1, parseInt(it.quantity, 10) || 1) };
      var props = normalizeProperties(it.properties);
      if (Object.keys(props).length) row.properties = props; /* e.g. gift message */
      return row;
    });
    if (!items.length) return Promise.reject(new Error('No items'));
    /* Same set already being added (double tap) — join silently. */
    var batchKey = items.map(function (it) { return it.id + 'x' + it.quantity + (it.properties ? JSON.stringify(it.properties) : ''); }).join(',');
    if (pendingBatches[batchKey]) return pendingBatches[batchKey];
    inFlightMutation = true;
    setLoading(true);
    open();
    var req = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (json) {
          if (!response.ok) throw json;
          return json;
        });
      })
      .then(function (json) {
        inFlightMutation = false;
        refreshQueued = false;
        setLoading(false);
        emitAdded(items, json);
        return refreshCart(true).then(function () { return json; });
      }, function (error) {
        inFlightMutation = false;
        refreshQueued = false;
        setLoading(false);
        if (lastServerCart) applyCart(lastServerCart);
        showCartError(error && (error.description || error.message));
        throw error;
      });
    pendingBatches[batchKey] = req;
    var clear = function () { delete pendingBatches[batchKey]; };
    req.then(clear, clear);
    return req;
  }
  var pendingBatches = {};

  /* Drop-in replacement for fetch('/cart/add.js', {body}) used by every
     custom add button: returns a Response so existing .then(r => r.json())
     chains keep working, but goes through the drawer's optimistic,
     de-duplicated, error-aware pipeline. */
  function miravaCartPost(body) {
    body = body || {};
    /* With product info (name/price/img) we can show an instant optimistic
       row; without it, one confirmed request then the real cart. */
    var p = (!body.items && body.info)
      ? miravaExternalAddToCart(body.id, body.quantity, body.info)
      : miravaAddItems(body.items || [{ id: body.id, quantity: body.quantity }]);
    return p.then(function (json) {
      return new Response(JSON.stringify(json || {}), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    });
  }

  window.MiravaAddToCart = miravaExternalAddToCart;
  window.MiravaAddItems = miravaAddItems;
  window.MiravaCartPost = miravaCartPost;
  /* delegated actions — quantity/remove go through the optimistic queue
     (instant UI, one coalesced request at a time). */
  /* Remove-item confirmation (admin toggle: cart_confirm_remove) */
  var confirmModal = drawer.querySelector('[data-remove-confirm]');

  function askRemoveConfirm(btn, key) {
    if (!confirmModal) {
      queueChange(key, 0);
      return;
    }
    var row = btn.closest('.item');
    var nameEl = row ? row.querySelector('.name') : null;
    var metaEl = row ? row.querySelector('.meta') : null;
    var img = row ? row.querySelector('.thumb img') : null;
    var box = confirmModal.querySelector('[data-confirm-item]');
    if (box) {
      box.innerHTML =
        (img
          ? '<img src="' +
            (img.currentSrc || img.getAttribute('src')) +
            '" alt="">'
          : '') +
        '<div><div class="mirava-confirm__name">' +
        ((nameEl && nameEl.textContent) || 'this item') +
        '</div><div class="mirava-confirm__meta">' +
        ((metaEl && metaEl.textContent) || '') +
        '</div></div>';
    }
    confirmModal.__pendingKey = key;
    confirmModal.hidden = false;
  }

  if (confirmModal) {
    confirmModal.addEventListener('click', function (e) {
      if (
        e.target.closest('[data-confirm-cancel]') ||
        e.target === confirmModal
      ) {
        confirmModal.hidden = true;
        confirmModal.__pendingKey = null;
        return;
      }
      if (e.target.closest('[data-confirm-remove]')) {
        var pendingKey = confirmModal.__pendingKey;
        confirmModal.hidden = true;
        confirmModal.__pendingKey = null;
        if (pendingKey) queueChange(pendingKey, 0);
      }
    });
  }

  drawer.addEventListener('click', function (e) {
    var closeBtn =
      e.target.closest('[data-close-cart]');

    if (closeBtn) {
      close();
      return;
    }

    /* Disabled empty-cart checkout must never navigate. */
    if (
      e.target.closest(
        'a.checkout.is-disabled'
      )
    ) {
      e.preventDefault();
      return;
    }

    /* Total breakdown toggle (Round 2). Round 7: .summary-open also hides
       the MRP strike — the open summary shows the same MRP figure as a row,
       so keeping both stacks ₹X twice in one view. */
    if (
      totalToggleEl &&
      totalDetailsEl &&
      e.target.closest('[data-total-toggle]')
    ) {
      var detailsOpen = totalDetailsEl.hidden;
      totalDetailsEl.hidden = !detailsOpen;
      totalToggleEl.setAttribute(
        'aria-expanded',
        detailsOpen ? 'true' : 'false'
      );
      drawer.classList.toggle('summary-open', detailsOpen);
      return;
    }

    /* Gift popup dismiss (Round 3) */
    if (
      giftPopupEl &&
      e.target.closest('[data-gift-dismiss]')
    ) {
      giftPopupEl.hidden = true;
      giftDismissed = true;
      return;
    }

    /* Coupons sub-drawer close (Round 5) */
    if (
      coupsDrawerEl &&
      e.target.closest('[data-coupons-close]')
    ) {
      coupsDrawerEl.hidden = true;
      return;
    }

    var act =
      e.target.closest('[data-action]');

    if (act) {
      var key =
        act.getAttribute('data-key');

      var action =
        act.getAttribute('data-action');

      if (
        action === 'remove' &&
        key
      ) {
        if (
          window.MIRAVA_CART_CONFIG &&
          window.MIRAVA_CART_CONFIG.confirmRemove === false
        ) {
          queueChange(key, 0);
        } else {
          askRemoveConfirm(act, key);
        }

      } else if (
        action === 'inc' &&
        key
      ) {
        queueChange(key, 'inc');

      } else if (
        action === 'dec' &&
        key
      ) {
        var decRow = act.closest('.item');
        var decQtyEl = decRow
          ? decRow.querySelector('.qty span')
          : null;
        var decQty = decQtyEl
          ? parseInt(decQtyEl.textContent, 10)
          : NaN;
        if (
          decQty === 1 &&
          !(
            window.MIRAVA_CART_CONFIG &&
            window.MIRAVA_CART_CONFIG.confirmRemove === false
          )
        ) {
          askRemoveConfirm(act, key);
        } else {
          queueChange(key, 'dec');
        }

      } else if (action === 'coupon-apply') {
        if (!act.disabled) {
          act.disabled = true;
          act.setAttribute(
            'data-busy-text',
            act.textContent
          );
          act.textContent = 'Applying\u2026';
        }
        postCouponDiscount(
          act.getAttribute('data-code') || ''
        );

      } else if (action === 'coupon-remove') {
        postCouponDiscount('');

      } else if (action === 'coupons-open') {
        if (coupsDrawerEl) coupsDrawerEl.hidden = false;

      } else if (action === 'coupon-details') {
        /* Round 8: per-card T&C expander (prototype "View details"). */
        var detailsList =
          act.parentElement &&
          act.parentElement.querySelector('.coup-details-list');
        var detailsOpen =
          act.getAttribute('aria-expanded') === 'true';
        act.setAttribute(
          'aria-expanded',
          detailsOpen ? 'false' : 'true'
        );
        if (detailsList) detailsList.hidden = detailsOpen;

      } else if (action === 'gift-claim') {
        if (!act.disabled) {
          act.disabled = true;
          act.setAttribute(
            'data-busy-text',
            act.textContent
          );
          act.textContent = 'Adding\u2026';
        }
        claimGift();

      } else if (action === 'add') {
        /* .add is the actual button — busy state goes there, not the card. */
        var addBtn =
          e.target.closest(
            '[data-action="add"]'
          );

        var addCard =
          addBtn
            ? addBtn.closest('[data-add-one]')
            : null;

        var vid =
          addCard
            ? addCard.getAttribute('data-add-one')
            : '';

        /* Per-product lock only (pendingAddIds) — a single global "any add
           in flight" flag used to block adding a SECOND, different upsell
           product while the first one's request was still pending, which
           made rapid-fire add clicks on different cards silently do
           nothing. Two different products can add concurrently; the same
           product still can't be double-added mid-flight. */
        if (
          addBtn &&
          addCard &&
          vid &&
          !pendingAddIds[vid]
        ) {
          pendingAddIds[vid] = true;

          addBtn.classList.add(
            'is-busy'
          );

          var ups = findUpsell(vid);

          if (ups) {
            injectSyntheticLine(ups);
          }

          applyOptimistic();

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: vid, quantity: 1 })
          })
            .then(function (r) {
              if (!r.ok) {
                return r.json().catch(function () { return null; }).then(function (body) {
                  var err = new Error('Add to cart failed');
                  err.detail = body && (body.description || body.message);
                  throw err;
                });
              }
              return r.json();
            })
            .then(function () { return refreshCart(true); })
            .catch(function (err) {
              removeSyntheticLines();
              applyOptimistic();
              showCartError(err && typeof err.detail === 'string' && err.detail ? err.detail : undefined);
            })
            .then(function () {
              delete pendingAddIds[vid];
              addBtn.classList.remove('is-busy');
              applyOptimistic();
              renderUpsell();
            });
        }
      }

      return;
    }
  });

  /* ===== Round 2: coupon tiers (list + locked states) + total breakdown ===== */
  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function couponApplied(code) {
    var codes = (curCart && curCart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (
        String(codes[i].code || '').toUpperCase() ===
        String(code).toUpperCase()
      ) {
        /* A code can stay attached but be inapplicable (expired/invalid) —
           only a genuinely applicable or money-bearing entry counts. */
        return (
          codes[i].applicable === true ||
          (typeof codes[i].amount === 'number' && codes[i].amount > 0)
        );
      }
    }
    return false;
  }

  function couponAmount(code) {
    var codes = (curCart && curCart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (
        String(codes[i].code || '').toUpperCase() ===
        String(code).toUpperCase()
      ) {
        return codes[i].amount || 0;
      }
    }
    return 0;
  }

  /* Round 11: animated discount icon (prototype's discount.gif), served
     from theme assets — used in every coupon-related surface. */
  var iconRoot =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    '/';
  var COUP_ICON_HTML =
    '<img class="coup-disc-icon" src="' +
    iconRoot +
    'assets/mirava-discount.gif" alt="" aria-hidden="true">';
  var COUP_ARROW_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function couponCardHTML(c, inDrawer) {
    var sub =
      (curCart.items_subtotal_price ||
        curCart.total_price ||
        0) / 100;
    var applied = couponApplied(c.code);
    var belowMin = !applied && sub < c.min;
    var save = Math.floor(sub * c.pct) / 100;

    /* Round 10: no lock UI (prototype has none) — the Apply button is
       always visible and simply stays disabled until the minimum is met. */
    var badgeText = applied
      ? escAttr(c.code) + ' applied'
      : 'Save ' + fmtINR(save);

    var html =
      '<div class="coup' +
      (applied ? ' is-applied' : '') +
      '">' +
      '<div class="coup-row">' +
      '<span class="save-badge">' +
      COUP_ICON_HTML +
      '<span>' +
      badgeText +
      '</span></span>' +
      (!applied
        ? '<span class="coupon-border-box">' + escAttr(c.code) + '</span>'
        : '');

    if (applied) {
      html +=
        '<button type="button" class="coup-btn coup-btn--remove" data-action="coupon-remove" aria-label="Remove coupon">Remove</button>';
    } else {
      html +=
        '<button type="button" class="coup-btn"' +
        (belowMin ? ' disabled' : '') +
        ' data-action="coupon-apply" data-code="' +
        escAttr(c.code) +
        '">Apply</button>';
    }

    html += '</div>';

    /* Round 8: drawer cards get a "View details" T&C expander. */
    if (inDrawer) {
      html +=
        '<div class="coup-meta">' +
        '<button type="button" class="coup-details-toggle" data-action="coupon-details" aria-expanded="false">View details ' +
        COUP_ARROW_SVG +
        '</button>' +
        '<ul class="coup-details-list" hidden>' +
        '<li>Flat ' +
        c.pct +
        '% off the order total</li>' +
        '<li>Valid on minimum purchase of ' +
        fmtINR(c.min) +
        '</li>' +
        '</ul>' +
        '</div>';
    }

    return html + '</div>';
  }

  function renderCoupons() {
    if (!coupsEl) return;
    var tiers = CFG.coupons || [];

    if (
      !tiers.length ||
      !curCart ||
      curCart.item_count === 0
    ) {
      coupsEl.hidden = true;
      coupsEl.innerHTML = '';
      if (coupsViewEl) {
        coupsViewEl.hidden = true;
        coupsViewEl.innerHTML = '';
      }
      if (coupsDrawerListEl) coupsDrawerListEl.innerHTML = '';
      return;
    }

    /* Full tier list lives in the sub-drawer, grouped prototype-style:
       unlocked under "Available coupons", locked under "Unlock coupons". */
    if (coupsDrawerListEl) {
      var subDrawer =
        (curCart.items_subtotal_price ||
          curCart.total_price ||
          0) / 100;
      var unlockedTiers = tiers.filter(function (c) {
        return subDrawer >= c.min;
      });
      var lockedTiers = tiers.filter(function (c) {
        return subDrawer < c.min;
      });
      coupsDrawerListEl.innerHTML =
        (unlockedTiers.length
          ? '<div class="coups-group">Available coupons</div>' +
            unlockedTiers
              .map(function (c) {
                return couponCardHTML(c, true);
              })
              .join('')
          : '') +
        (lockedTiers.length
          ? '<div class="coups-group">Unlock coupons</div>' +
            lockedTiers
              .map(function (c) {
                return couponCardHTML(c, true);
              })
              .join('')
          : '');
    }

    /* Inline shows only the best card: applied > first unlocked > first tier. */
    var sub =
      (curCart.items_subtotal_price ||
        curCart.total_price ||
        0) / 100;
    var best = tiers.filter(function (c) {
      return couponApplied(c.code);
    })[0];
    if (!best) {
      best = tiers.filter(function (c) {
        return sub >= c.min;
      })[0];
    }

    /* Round 8: count = TOTAL configured offers (his spec: 1 coupon → +1,
       5 coupons → +5), grey like the prototype; both links share one
       action (open the coupon drawer). Rendered FIRST so it survives the
       no-unlocked-coupon early return below. */
    if (coupsViewEl) {
      coupsViewEl.hidden = false;
      coupsViewEl.innerHTML =
        '<button type="button" class="coups-view__enter" data-action="coupons-open">Enter A Coupon</button>' +
        '<button type="button" class="coups-view__count" data-action="coupons-open">+' +
        tiers.length +
        ' offer(s) available ' +
        COUP_ARROW_SVG +
        '</button>';
    }

    /* Round 9C revised (his feedback: box ALWAYS visible like the prototype):
       applied > unlocked > first tier. Below-threshold shows the locked
       card (lock + min-order hint) instead of hiding the strip. */
    if (!best) best = tiers[0];

    if (!best) {
      coupsEl.hidden = true;
      coupsEl.innerHTML = '';
      return;
    }

    var html = couponCardHTML(best);

    coupsEl.hidden = false;
    coupsEl.innerHTML = html;
  }

  function renderTotalDetails() {
    if (!totalDetailsEl) return;
    var serverDiscount = curCart ? curCart.total_discount || 0 : 0;
    var subPaise = curCart
      ? curCart.items_subtotal_price || curCart.total_price || 0
      : 0;
    /* Round 6: MRP figures come from cartMrpTotal() (mrpCache-driven) so the
       summary, total-row stack and savings badge always agree. */
    var mrpTotal = curCart ? cartMrpTotal() : 0;
    var mrpSave = Math.max(0, mrpTotal - subPaise);

    /* Round 7: "Subtotal (MRP)" only when an MRP markdown actually exists —
       otherwise a plain "Subtotal" (no phantom MRP claim). */
    var rows =
      '<div class="td-row"><span>' +
      (mrpSave > 0 ? 'Subtotal (MRP)' : 'Subtotal') +
      '</span><span>' +
      fmtINR(mrpTotal / 100) +
      '</span></div>';

    if (mrpSave > 0) {
      rows +=
        '<div class="td-row"><span>Discount on MRP</span><span>\u2212' +
        fmtINR(mrpSave / 100) +
        '</span></div>';
    }

    if (serverDiscount > 0) {
      var appliedCode =
        ((curCart.discount_codes || [{}])[0] || {}).code || '';
      rows +=
        '<div class="td-row"><span>Coupon (' +
        escAttr(appliedCode) +
        ')</span><span>\u2212' +
        fmtINR(serverDiscount / 100) +
        '</span></div>';
    }

    /* Round 4: informational prepaid savings row (display-only). */
    if (
      CFG.prepaid &&
      CFG.prepaid.on &&
      curCart &&
      curCart.total_price > 0
    ) {
      rows +=
        '<div class="td-row td-prepaid"><span>Pay online &amp; save ' +
        CFG.prepaid.pct +
        '%</span><span>\u2212' +
        fmtINR(
          Math.round(
            (curCart.total_price * CFG.prepaid.pct) / 100 / 100
          )
        ) +
        '</span></div>';
    }

    rows +=
      '<div class="td-row td-muted"><span>Shipping</span><span>Calculated at checkout</span></div>';

    totalDetailsEl.innerHTML = rows;
  }

  /* ===== Round 3: free-gift claim (popup toggle + banner + enforce) ===== */
  function giftVariantId() {
    return CFG.gift ? String(CFG.gift.id) : '';
  }

  function giftLine() {
    var gvid = giftVariantId();
    if (!gvid || !curCart) return null;
    var items = curCart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === gvid) return items[i];
    }
    return null;
  }

  /* Eligibility deliberately EXCLUDES the gift line's own value so a paid
     gift can never keep itself alive at its own threshold. */
  function giftEligibleSubtotal() {
    if (!curCart) return 0;
    var gvid = giftVariantId();
    var sub = 0;
    var items = curCart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (gvid && String(items[i].variant_id) === gvid) continue;
      sub +=
        items[i].final_line_price ||
        items[i].line_price ||
        0;
    }
    return sub / 100;
  }

  function tagGiftItem() {
    var line = giftLine();
    if (!line || !itemsEl) return;
    var btn = itemsEl.querySelector(
      '[data-key="' + line.key + '"]'
    );
    var row = btn ? btn.closest('.item') : null;
    if (row && !row.classList.contains('is-gift')) {
      row.classList.add('is-gift');
      var nameElGift = row.querySelector('.name');
      var tag = document.createElement('span');
      tag.className = 'gift-tag';
      tag.textContent = 'FREE GIFT';
      if (nameElGift && nameElGift.parentNode) {
        nameElGift.parentNode.insertBefore(tag, nameElGift.nextSibling);
      }
    }
  }

  function renderGiftState() {
    if (giftBannerEl) {
      var showBanner =
        !!CFG.gift &&
        CFG.gift.banner !== false &&
        curCart &&
        curCart.item_count > 0 &&
        giftEligibleSubtotal() >= FREE_GIFT &&
        !giftLine();
      giftBannerEl.hidden = !showBanner;
    }

    if (!CFG.gift) return;

    var eligible =
      curCart &&
      curCart.item_count > 0 &&
      giftEligibleSubtotal() >= FREE_GIFT;
    var inCart = !!giftLine();

    /* Enforce: threshold gir gaya to gift silently auto-remove. */
    if (inCart && !eligible) {
      queueChange(giftLine().key, 0);
      return;
    }

    if (inCart && giftPopupEl && !giftPopupEl.hidden) {
      giftPopupEl.hidden = true;
    }

    var justUnlocked = eligible && !inCart;
    if (
      justUnlocked &&
      CFG.gift.popup !== false &&
      !giftDismissed &&
      !giftPopupShown &&
      giftPopupEl
    ) {
      if (giftItemEl) {
        giftItemEl.innerHTML =
          (CFG.gift.img
            ? '<img src="' + CFG.gift.img + '" alt="">'
            : '') +
          '<span>' +
          escAttr(CFG.gift.title || 'Free gift') +
          '</span>';
      }
      giftPopupEl.hidden = false;
      giftPopupShown = true;
    }
  }

  function claimGift() {
    if (!CFG.gift || giftClaiming) return;
    if (giftLine()) {
      if (giftPopupEl) giftPopupEl.hidden = true;
      return;
    }
    giftClaiming = true;
    inFlightMutation = true;

    var root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: CFG.gift.id,
        quantity: 1
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Gift add failed');
        return r.json();
      })
      .then(function () {
        giftClaiming = false;
        if (giftPopupEl) giftPopupEl.hidden = true;
        inFlightMutation = false;
        refreshQueued = false;
        refreshCart(true).catch(function () {
          showCartError();
        });
      })
      .catch(function () {
        giftClaiming = false;
        inFlightMutation = false;
        showCartError();
        resetBusyButtons('[data-action="gift-claim"]');
      });
  }

  /* Round 4: restore busy-marked buttons after a failed async action. */
  function resetBusyButtons(selector) {
    var btns = drawer.querySelectorAll(selector);
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].disabled) {
        btns[i].disabled = false;
        var busyText = btns[i].getAttribute('data-busy-text');
        if (busyText) {
          btns[i].textContent = busyText;
          btns[i].removeAttribute('data-busy-text');
        }
      }
    }
  }

  /* Shared poster for the coupon cards: /cart/update.js { discount } is the
     documented way to attach codes; empty string clears them. */
  function postCouponDiscount(code) {
    if (discountInFlight) return;
    discountInFlight = true;

    var root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Discount request failed');
        return r.json();
      })
      .then(function (cart) {
        discountInFlight = false;
        tryApplyCart(nextMutationSeq(), cart);
        renderCoupons();
        renderTotalDetails();
        if (discMsg) {
          setDiscMsg(
            code ? 'Code ' + code + ' applied.' : 'Coupon removed.',
            false
          );
        }
      })
      .catch(function () {
        discountInFlight = false;
        if (discMsg) {
          setDiscMsg('Could not apply that code right now.', true);
        }
        resetBusyButtons('[data-action="coupon-apply"]');
      });
  }

  /* Real Shopify discount code — applied via POST /cart/update.js { discount: CODE },
     then the cart is re-fetched from /cart.js so total and savings are Shopify's
     own numbers. */
  function setDiscMsg(text, isError) {
    if (!discMsg) return;

    if (!text) {
      discMsg.hidden = true;
      discMsg.textContent = '';
      discMsg.classList.remove(
        'is-error'
      );
      return;
    }

    discMsg.hidden = false;
    discMsg.textContent = text;

    discMsg.classList.toggle(
      'is-error',
      !!isError
    );
  }

  function finishDiscountApply(buttonLabel) {
    discountInFlight = false;

    if (discApply) {
      discApply.disabled = false;
      discApply.textContent = buttonLabel;
    }
  }

  function applyDiscount() {
    if (
      discountInFlight ||
      !discApply
    ) {
      return;
    }

    var code =
      discInput
        ? discInput.value.trim()
        : '';

    if (!code) {
      setDiscMsg(
        'Enter a discount code.',
        true
      );
      return;
    }

    var buttonLabel =
      discApply.textContent;

    discountInFlight = true;

    discApply.disabled = true;
    discApply.textContent =
      'Applying\u2026';

    setDiscMsg('');

    var root =
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) || '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: code
      })
    })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return null; }).then(function (body) {
          throw new Error((body && (body.description || body.message)) || 'Discount request failed');
        });
        return r.json();
      })
      .then(function (data) {
        var codes =
          (data && data.discount_codes) || [];

        var match = null;

        for (var i = 0; i < codes.length; i++) {
          if (
            String(
              codes[i].code || ''
            ).toUpperCase() ===
            code.toUpperCase()
          ) {
            match = codes[i];
          }
        }

        return refreshCart().then(function () {
          finishDiscountApply(
            buttonLabel
          );

          if (
            match &&
            match.applicable === false
          ) {
            setDiscMsg(
              'That code isn\u2019t valid for this cart.',
              true
            );
            return;
          }

          if (!match || match.applicable === false) {
            setDiscMsg(
              'That code isn\u2019t valid for this cart.',
              true
            );
            return;
          }

          setDiscMsg(
            'Code ' +
            code.toUpperCase() +
            ' applied.',
            false
          );

          if (discInput) {
            discInput.value = '';
          }
        });
      })
      .catch(function () {
        finishDiscountApply(
          buttonLabel
        );

        setDiscMsg(
          'Could not apply the code. Please try again.',
          true
        );
      });
  }

  if (
    discToggle &&
    discPanel
  ) {
    discToggle.addEventListener(
      'click',
      function () {
        var shouldOpen =
          discPanel.hidden;

        discPanel.hidden = !shouldOpen;

        discToggle.setAttribute(
          'aria-expanded',
          shouldOpen ? 'true' : 'false'
        );

        discToggle.classList.toggle(
          'is-open',
          shouldOpen
        );
      }
    );
  }

  if (discApply) {
    discApply.addEventListener(
      'click',
      applyDiscount
    );
  }

  if (discInput) {
    discInput.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDiscount();
        }
      }
    );
  }

  /* Escape close only - outside-click close handled by overlay-close backdrop */
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Escape') {
        close();
      }
    }
  );

  /* Milestone positioning is owned by CSS (attribute selectors with
     data-pos) — no JS inline positioning, so the two can't conflict. */

  /* Initial load: refresh silently — the drawer is closed, so a failure here
     must not surface an error panel (the next open() refresh reports it). */
  refreshCart().catch(function () {});
})();
